<template>
  <b-form-group :class="containerClass" :invalid-feedback="invalidFeedback" :state="inputState" :description="hint">
    <!--label for="input-id" class="text-muted" v-if="label">{{label}}</label-->
    <label for="input-id" v-if="label">{{ label }}</label>
    <c-info-message v-if="infoMessage">
      {{ infoMessage }}
    </c-info-message>

    <b-form-select v-if="isComboBox" class="form-control" v-model="input" v-bind="$props" :state="inputState">
      <template slot="first">
        <slot name="first"></slot>
      </template>
    </b-form-select>

    <vue-multiselect
      v-else-if="isMultiSelect" v-model="input" v-bind="{...$props, ...$attrs}"
      label="text" track-by="value"
      :multiple="true" :taggable="true" :searchable="false" :close-on-select="false"
      select-label="Cliquez pour ajouter" selected-label="Sélectionné"
      deselect-label="Cliquez pour retirer"
    />

    <vue-select v-else-if="isAutocompleteSelect" v-model="input" v-bind="$props" label="text" class=""
                :reduce="option => option.value" :state="inputState">
    </vue-select>

    <vue-bootstrap-typeahead v-else-if="isAutocompleteInput" ref="autocompleteInput" v-model="input" v-bind="$props"
                             :data="options" :serializer="item => item.text" :minMatchingChars="0"
                             @hit="$emit('select', $event.value)">
    </vue-bootstrap-typeahead>

    <b-form-textarea v-else-if="isTextArea" class="form-control" v-bind="$props"
                     v-model="input" :state="inputState">
    </b-form-textarea>

    <vue-tel-input v-else-if="isTelInput"
                   wrapperClasses="tel-input-container" inputClasses="form-control tel-input"
                   defaultCountry="CM"
                   v-bind="$props" v-model="input">
    </vue-tel-input>

    <b-form-group v-else-if="isImageInput" class="input-wrapper text-center">
      <b-image thumbnail :src="picture" alt="Image" id="img" class="mb-2" @click="() => {}"
               title="Agrandir l'image" v-b-tooltip.hover.right>
      </b-image>
      <b-container class="px-xl-5 px-lg-3 px-md-1" v-show="!hideSelect">
        <b-button variant="secondary" class="mr-1" @click="$refs.imageInput.click()">
          <i class="icon-picture"></i>
          {{ placeholder }}
        </b-button>
        <b-button variant="danger" @click="clearInput" title="Supprimer la photo" v-d-tooltip.hover v-if="textEntered">
          <i class="fa fa-trash"></i>
        </b-button>
        <input type="file" ref="imageInput" class="hidden" accept="image/*" @change="onFileChange"/>
      </b-container>
    </b-form-group>

    <b-input-group v-else-if="isFileInput" class="input-wrapper text-center">
      <b-input-group-addon class="flex-fill" prepend>
        <b-form-input class="" :value="filename" disabled/>
      </b-input-group-addon>
      <input type="file" ref="fileInput" class="hidden" @change="onFileChange"/>
      <b-input-group-append>
        <b-button variant="secondary" @click="$refs.fileInput.click()">
          <i class="fa fa-upload mr-1"></i> Parcourir...
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-input-group v-else-if="isPriceInput">
      <b-form-input type="number" class="form-control" v-model="input" v-bind="$props" :state="inputState" min="0"
                    id="input-id"/>
      <b-input-group-append>
        <b-input-group-text>{{ currency }}</b-input-group-text>
      </b-input-group-append>
    </b-input-group>

    <b-input-group v-else-if="isQuantityInput">
      <b-form-input type="number" class="form-control" v-model="input" v-bind="$props" :state="inputState" min="0"
                    step="1" id="input-id"/>
      <b-input-group-append>
        <b-input-group-text>{{ unit }}</b-input-group-text>
      </b-input-group-append>
    </b-input-group>

    <b-input-group v-else-if="isQuantityUnitInput">
      <b-form-input type="number" class="form-control" v-model="input" v-bind="$props" :state="inputState" min="0"
                    step="1" id="input-id"/>
      <b-input-group-append>
        <b-form-select v-model="input2" :options="units" id="unit-select" class="form-control" :disabled="unitDisabled">
          <template slot="first">
            <option :value="null">--</option>
          </template>
        </b-form-select>
      </b-input-group-append>
    </b-input-group>

    <b-input-group v-else-if="isFilenameInput">
      <b-form-input class="form-control" v-model="input" v-bind="$props" :state="inputState" id="input-id"/>
      <b-input-group-append v-if="extension">
        <b-input-group-text>{{ extension }}</b-input-group-text>
      </b-input-group-append>
    </b-input-group>

    <b-input-group v-else-if="isDatetimeInput">
      <b-input-group-prepend>
        <b-input-group-text><i class="material-icons">schedule</i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="date" class="form-control" v-model="date" v-bind="$props" :state="inputState"/>
      <b-form-input type="time" class="form-control" v-model="time" v-bind="$props" :state="inputState" :step="1"/>
    </b-input-group>

    <b-input-group v-else-if="isDateInput">
      <b-input-group-prepend>
        <b-input-group-text><i class="material-icons">today</i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="date" class="form-control" v-model="input" v-bind="$props" :state="inputState"/>
    </b-input-group>

    <b-input-group v-else-if="isColorInput">
      <b-form-input type="color" class="form-control" v-model="input" v-bind="$props" :state="inputState"
                    id="input-id"/>
      <b-form-input type="text" class="form-control input-group-append" v-model="input" v-bind="$props"
                    :state="inputState"/>
    </b-input-group>

    <b-form-group v-else class="input-wrapper">
      <b-form-input :type="inputType" class="form-control" v-model="input" v-bind="$props" :state="inputState"
                    id="input-id"/>
      <b-form-text class="bg-transparent cursor-pointer text-center text-dark" id="eye" @click="togglePasswordVisible"
                   :title="eyeTooltip" v-b-tooltip.hover v-if="isPasswordInput && textEntered">
        <i :class="eyeIcon"></i>
      </b-form-text>
    </b-form-group>
  </b-form-group>
</template>

<script>
import Vue from "vue"
import {VueTelInput} from "vue-tel-input"
import VueSelect from "vue-select"
import _VueBootstrapTypeahead from "vue-bootstrap-typeahead"
import VueMultiselect from "vue-multiselect"
import {env} from "@/helpers"

const VueBootstrapTypeahead = Vue.extend({
  mixins: [_VueBootstrapTypeahead, {
    watch: {
      value(newValue) {
        this.inputValue = newValue
      }
    }
  }]
})

export default {
  name: "Input",
  props: [
    "type", "value", "container-class", "label", "placeholder", "state", "default", "currency", "options", "disabled",
    "unit", "units", "unit-disabled", "hide-select", "hint", "readonly", "extension", "rows", "step"
  ],
  components: {VueTelInput, VueSelect, VueBootstrapTypeahead, VueMultiselect},
  data() {
    return {
      input: this.value,
      input2: this.unit || this.time,
      filename: "-- Aucun fichier sélectionné --",
      passwordVisible: false,
    }
  },
  computed: {
    isPasswordInput() {
      return this.type === "password"
    },
    isTextArea() {
      return this.type === "textarea"
    },
    isImageInput() {
      return this.type === "image"
    },
    isFileInput() {
      return this.type === "file"
    },
    isTelInput() {
      return this.type === "tel"
    },
    isPriceInput() {
      return this.type === "price"
    },
    isQuantityInput() {
      return this.type === "quantity"
    },
    isQuantityUnitInput() {
      return this.type === "quantity-unit"
    },
    isComboBox() {
      return this.type === "select"
    },
    isMultiSelect() {
      return this.type === "multiselect"
    },
    isDateInput() {
      return this.type === "date"
    },
    isDatetimeInput() {
      return this.type === "datetime"
    },
    isAutocompleteSelect() {
      return this.type === "autocomplete-select"
    },
    isAutocompleteInput() {
      return this.type === "autocomplete-input"
    },
    isColorInput() {
      return this.type === "color"
    },
    isFilenameInput() {
      return this.type === "filename"
    },
    inputType() {
      if (!this.type || (this.isPasswordInput && this.passwordVisible))
        return "text"

      if (this.type === "price")
        return "number"

      return this.type
    },
    eyeTooltip() {
      return this.passwordVisible ? "Masquer le mot de passe" : "Afficher le mot de passe"
    },
    eyeIcon() {
      return this.passwordVisible ? "fa fa-eye-slash" : "fa fa-eye"
    },
    textEntered() {
      return this.input && this.input.length > 0
    },
    picture() {
      return this.input ? this.input : env(this.default || "DEFAULT_PICTURE")
    },
    invalidFeedback() {
      if (this.$slots.default && typeof this.$slots.default !== "string")
        return this.$slots.default[0].text

      return this.$slots.default
    },
    infoMessage() {
      if (this.$slots.infoMessage && typeof this.$slots.infoMessage !== "string")
        return this.$slots.infoMessage[0].text

      return this.$slots.infoMessage
    },
    inputState() {
      return this.state === true ? null : this.state
    },
    date: {
      get() {
        if (!this.input)
          return ""

        return this.input.split(" ")[0]
      },
      set(value) {
        const parts = this.input.split(" ")
        if (parts.length >= 2)
          value += " " + parts[1]

        this.input = value
      }
    },
    time: {
      get() {
        if (!this.input)
          return ""

        const parts = this.input.split(" ")

        return parts.length >= 2 ? parts[1] : ""
      },
      set(value) {
        const parts = this.input.split(" ")

        this.input = parts[0] + " " + value
      }
    }
  },
  watch: {
    input(val) {
      this.$emit("input", val)
    },
    value(val) {
      this.input = val
    }
  },
  methods: {
    togglePasswordVisible() {
      this.passwordVisible = !this.passwordVisible
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length)
        return

      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.input = e.target.result
      }
      reader.readAsDataURL(files[0])
      vm.filename = files[0].name
    },
    clearInput() {
      this.input = null
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
label {
  font-weight: bold;
  margin-bottom: 0;
}

.form-control[type=password] {
  padding-right: 25px;
}

.form-control.is-invalid {
  background-image: none;
}

select.form-control.is-invalid {
  //background-position: right calc() center;
  background-position: right center;
}

input::-ms-reveal {
  display: none;
}

.input-wrapper {
  position: relative;
  margin-bottom: 0;
}

#eye {
  position: absolute;
  top: 4px;
  right: 11px;
  font-size: 12px;
  height: 12px;
  width: 12px;
}

#img {
  max-height: 200px;
  object-fit: cover;
  cursor: zoom-in;
}

#remove-img-btn {
  position: absolute;
  padding: 0 5px;
  top: -8px;
  right: -8px;
}

.input-group-append {
  min-width: 50px;
}

.input-group-text {
  width: 100%;
  justify-content: center;
}
</style>
